var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAlert(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(5 7)",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.8 10.82L8.796.726A1.506 1.506 0 007.5 0c-.535 0-1.03.277-1.297.727L.201 10.819a1.416 1.416 0 000 1.454c.267.45.762.727 1.297.727h12.004c.535 0 1.03-.277 1.297-.727a1.417 1.417 0 000-1.454z",
    stroke: "#0B0B0B",
    strokeWidth: 1.1,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.751 4.811v3.034c0 .401.335.726.749.726a.738.738 0 00.749-.726V4.81a.738.738 0 00-.749-.727.738.738 0 00-.749.727z",
    fill: "#000",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#000",
    fillRule: "nonzero",
    cx: 7.5,
    cy: 9.857,
    r: 1
  }))));
}

export default SvgAlert;